type TreeNodeLike<T = unknown> = {
  id?: string | null
  children?: T[] | null
}

const HIDDEN_LAW_ROOT_IDS = new Set([
  'forskrift-1989-10-13-1041',
])

export function isHiddenLawId(id?: string | null): boolean {
  if (!id) {
    return false
  }

  const normalizedId = id.toLowerCase()

  for (const hiddenRoot of HIDDEN_LAW_ROOT_IDS) {
    if (normalizedId === hiddenRoot || normalizedId.startsWith(`${hiddenRoot}/`)) {
      return true
    }
  }

  return false
}

export function pruneHiddenLawNodes<T extends TreeNodeLike<T>>(nodes: T[] | null | undefined): T[] {
  if (!nodes?.length) {
    return []
  }

  const visibleNodes: T[] = []

  for (const node of nodes) {
    if (isHiddenLawId(node.id)) {
      continue
    }

    const visibleChildren = pruneHiddenLawNodes(node.children)

    visibleNodes.push({
      ...node,
      children: visibleChildren,
    } as T)
  }

  return visibleNodes
}
